import { addApprover, deleteApprover, getApprover, updateApprover } from 'API/approverApi';
import { showAlertMessage } from 'Features/alertMessage/alertMessageSlice';
import { INITIAL_APPROVER_VALUES } from 'Helpers/constant';
import { addApproverPayload, editApproverPayload } from 'Helpers/payload';
import { tWithErrorFallback, tWithSuccessFallback } from 'Hooks/useTranslationWithFallback';
import { useDispatch } from 'react-redux';

export const useApproverForm = (onClose) => {
  const dispatch = useDispatch();

  const handleAdd = async (data) => {
    const payload = addApproverPayload(data);

    return dispatch(addApprover(payload))
      .unwrap()
      .then(() => {
        dispatch(getApprover()).unwrap();
        onClose();
        dispatch(
          showAlertMessage({
            type: 'success',
            text: tWithSuccessFallback('approverManagement.success')
          })
        );
      })
      .catch((error) => {
        const messageKey = error?.messageKey ? error?.messageKey : error?.message;
        dispatch(
          showAlertMessage({
            type: 'error',
            text: tWithErrorFallback(`apiErrorMessages.${messageKey}`)
          })
        );
        throw error;
      });
  };

  const handleUpdate = async (data) => {
    const payload = editApproverPayload(data);

    return dispatch(
      updateApprover({
        payload,
        approverId: data.tags
      })
    )
      .unwrap()
      .then(() => {
        dispatch(getApprover()).unwrap();
        onClose();
        dispatch(
          showAlertMessage({
            type: 'success',
            text: tWithSuccessFallback('approverManagement.editSuccess')
          })
        );
      })
      .catch((error) => {
        const messageKey = error?.messageKey ? error?.messageKey : error?.message;
        dispatch(
          showAlertMessage({
            type: 'error',
            text: tWithErrorFallback(`apiErrorMessages.${messageKey}`)
          })
        );
        throw error;
      });
  };

  const handleDelete = async (approverId) => {
    return dispatch(deleteApprover({ approverId }))
      .unwrap()
      .then(() => {
        dispatch(getApprover()).unwrap();
        dispatch(
          showAlertMessage({
            type: 'success',
            text: tWithSuccessFallback('approverManagement.deleteApproverSuccess')
          })
        );
      })
      .catch((error) => {
        const messageKey = error?.messageKey ? error?.messageKey : error?.message;
        dispatch(
          showAlertMessage({
            type: 'error',
            text: tWithErrorFallback(`apiErrorMessages.${messageKey}`)
          })
        );
        throw error;
      });
  };

  const resetForm = (reset) => {
    reset(INITIAL_APPROVER_VALUES);
    onClose();
  };

  return {
    handleAdd,
    handleUpdate,
    handleDelete,
    resetForm
  };
};
